var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNotification)?_c('div',{staticClass:"notification-banner"},[_vm._v("\n\t"+_vm._s(_vm.notificationMsg)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }